import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export function useHotelBookingData() {

    const getHotelBookingData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}hotel/bookings${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    return {
        getHotelBookingData
    };

};